module.exports = __webpack_public_path__ + "img/6.9ca8c8f1.jpg";